'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _keysToObject = require('./keysToObject');

var _keysToObject2 = _interopRequireDefault(_keysToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an empty object with the same keys as the passed in object.
 * <pre>
 *     emptyObject({ a: '1', b: '2', c: '3' });
 *     // => { a: null, b: null, c: null }
 */
// Lib
exports.default = function (object) {
  return (0, _keysToObject2.default)(null, (0, _lodash.keys)(object));
};

// Util


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteLodash/emptyObject.js
// module id = 761
// module chunks = 0